import { render, staticRenderFns } from "./points_month.vue?vue&type=template&id=0dcf35f6"
import script from "./points_month.vue?vue&type=script&lang=js"
export * from "./points_month.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports